import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  width: 100%;
  max-height: none;
  overflow: visible;
`;

export const WrapperInput = styled.div`
  margin-bottom: 15px;
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
`;

export const SectionTitle = styled.h3`
  color: #122D58;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
`;

export const Row = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
`;

export const Column = styled.div`
  flex: 1;
`;

export const AutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AutocompleteDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 280px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
`;

export const AutocompleteItem = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
`;

